export enum UserTypesE {
  Undefined = 'Undefined',
  Chirp = 'Chirp',
  WarrCloud = 'WarrCloud',
}
